/** @format */
import { Modal, ModalProps } from "antd";
import classnames from "classnames";
import { ReactNode } from "react";
import styles from "./styles.module.scss";
import CloseCircleOutlined from "../../../assets/images/CloseCircleOutlined.svg";
interface IPropsModal extends ModalProps {
  titleHeader?: string | React.ReactElement;
  isModalVisible?: boolean;
  handleClose?: () => any;
  handleSubmit?: (data: any) => any;
  children: ReactNode;
  title?: string;
  okText?: string;
  cancelText?: string;
  width?: number;
  additionalClassName?: any;
  className?: string;
}

export const CommonModal = ({
  titleHeader,
  isModalVisible = true,
  handleClose,
  handleSubmit,
  children,
  title,
  width,
  additionalClassName,
  className,
  ...rest
}: IPropsModal) => {
  const handleOk = async () => {};
  const handleCancel = () => {
    // handleClose!();
  };
  return (
    <>
      <Modal
        title={title}
        centered
        open={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOk}
        width={width}
        closable={true}
        closeIcon={<img src={CloseCircleOutlined} alt="" />}
        className={classnames(styles.modal, className)}
        footer={false}
        maskStyle={{ background: "rgba(56, 56, 56, 0.7)" }}
        {...rest}
      >
        {titleHeader ? (
          <span className={styles.titleHeader}>{titleHeader}</span>
        ) : null}
        {children}
      </Modal>
    </>
  );
};
